import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState, useEffect, useMemo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from '../ui/checkbox';
import DataTable from '../ui/table';
import Input from '../ui/input-auto-complete';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import Validator from '../../utils/validator'; // api

import { createRoleRightAPI, editRoleRightAPI } from '../../api/userAPI'; // redux

import { clearDialogInfo } from '../../redux/user-management';
var t = i18n.getFixedT(null, 'user-management');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var initRoleRights = {
  id: null,
  name: '',
  permissions: []
};
var RightsEdit = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$userMana = _useSelector.userManagement.dialogInfo,
      mode = _useSelector$userMana.mode,
      data = _useSelector$userMana.data,
      menus = _useSelector.sessionObj.menus;

  var dispatch = useDispatch();
  var id = props.id,
      onClose = props.onClose;

  var _useState = useState(initRoleRights),
      _useState2 = _slicedToArray(_useState, 2),
      roleRightsData = _useState2[0],
      setRoleRightsData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var form_ref = useRef(null);
  useEffect(function () {
    if (mode.indexOf('rights.edit') >= 0) setRoleRightsData(data);
    if (mode.indexOf('rights.create') >= 0) setRoleRightsData(initRoleRights);
  }, [mode]);
  if (mode.indexOf('rights') < 0 || mode.indexOf('edit') > 0 && _.isEmpty(roleRightsData.id)) return null;

  var handleClose = function handleClose() {
    dispatch(clearDialogInfo());
    setRoleRightsData(initRoleRights);
    setError(null);
  };

  var handleChange = function handleChange(val) {
    setRoleRightsData(val);
  };

  var handleRightsChange = function handleRightsChange(val, type, currentItem) {
    var newRoleRightsData = _.cloneDeep(roleRightsData);

    var permissions = newRoleRightsData.permissions;
    var idAry = val.split('.');
    var parentId = currentItem.parentId;

    if (type === 'add') {
      permissions.push({
        id: val
      });

      var haveParentId = _.find(permissions, function (o) {
        return o.id === _.join(_.initial(idAry), '.');
      });

      while (idAry.length > 2 && !haveParentId) {
        idAry = _.initial(idAry);
        permissions.push({
          id: _.join(idAry, '.')
        });
      }
    } else {
      _.remove(permissions, function (el) {
        return el.id === val;
      });

      if (currentItem.authorizationType !== 'function') {
        (function () {
          var sameParentItem = _.filter(permissions, function (o) {
            return o.id !== parentId && o.id.indexOf(parentId) >= 0 && o.id.indexOf(val) === -1;
          });

          if (parentId && sameParentItem.length === 0) _.remove(permissions, function (el) {
            return el.id === parentId;
          });

          var childrenFunctions = _.filter(permissions, function (o) {
            return o.id.indexOf(val) >= 0;
          });

          while (childrenFunctions.length > 0) {
            _.remove(permissions, function (el) {
              return el.id === _.last(childrenFunctions).id;
            });

            childrenFunctions = _.initial(childrenFunctions);
          }
        })();
      }
    }

    setRoleRightsData(newRoleRightsData);
  };

  var handleConfirm = function handleConfirm() {
    // validate
    var requiredField = ['name'];
    var fillOutRequired = Validator(requiredField, roleRightsData);
    if (fillOutRequired.length > 0) return setError(et('txt-fill-out-required'));

    if (mode.indexOf('create') >= 0) {
      createRoleRightAPI(contextRoot, false, roleRightsData).then(function (result) {
        setRoleRightsData(initRoleRights);
        setError(null);
        onClose();
      }).catch(function (error) {
        setError(error.message);
      });
    } else {
      editRoleRightAPI(contextRoot, false, roleRightsData).then(function (result) {
        setRoleRightsData(initRoleRights);
        setError(null);
        onClose();
      }).catch(function (error) {
        setError(error.message);
      });
    }
  };

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    handler: handleConfirm
  });

  var fields = {};

  _.set(fields, 'name', {
    label: t('lbl-role-name'),
    editor: Input,
    props: {
      required: true,
      validate: {
        t: function t(code) {
          return et("txt-".concat(code));
        }
      }
    }
  });

  _.set(fields, 'rights', {
    label: '',
    editor: RightsTypeList,
    props: {
      // list: authList_all,
      menus: menus,
      // editable: editable,
      onCheckChange: handleRightsChange,
      permissions: roleRightsData.permissions
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: mode.indexOf('create') >= 0 ? t('dlg-create-role-right') : t('dlg-edit-role-right'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: roleRightsData
  }));
});
RightsEdit.defaultProps = {
  id: 'g-rights-edit'
};
RightsEdit.propTypes = {
  id: PropTypes.string
};
export default RightsEdit;

var generateRightsMenu = function generateRightsMenu() {
  var menus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var authorizations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // 將相同種類的權限先進行分組排序
  var groupMap = {};

  _.forEach(menus, function (menu) {
    var groupKey = menu.key.split('.')[1];
    if (!groupMap[groupKey]) groupMap[groupKey] = [];
    groupMap[groupKey].push(menu);
  });

  var groupedMenus = [];
  var usedGroup = new Set();

  _.forEach(menus, function (menu) {
    var groupKey = menu.key.split('.')[1];

    if (!usedGroup.has(groupKey)) {
      groupedMenus.push.apply(groupedMenus, _toConsumableArray(groupMap[groupKey]));
      usedGroup.add(groupKey);
    }
  }); // 產生權限列表


  var pageFunctionAry = _.filter(authorizations, function (o) {
    return o.authorizationType === 'function';
  });

  var noParentFunction = _.filter(pageFunctionAry, function (o) {
    return _.isEmpty(o.parentId);
  });

  var data = [];

  _.forEach(groupedMenus, function (menu) {
    var key = menu.key.split('.')[1];

    var extraFunction = _.filter(pageFunctionAry, function (o) {
      return o.id.indexOf(key) >= 0;
    });

    if (menu.pages.length === 1) {
      var isWeb = _.find(menus, function (o) {
        return o.key.indexOf("web.".concat(key)) >= 0;
      });

      var isEvms = _.find(menus, function (o) {
        return o.key.indexOf("evms.".concat(key)) >= 0;
      });

      var displayName = menu.displayNames[0].split('-')[1];

      if (!data.find(function (o) {
        return o.key === key;
      })) {
        data.push({
          displayName: displayName,
          key: key,
          isWeb: isWeb,
          isEvms: isEvms
        });
      }

      if (extraFunction.length > 0) {
        _.forEach(extraFunction, function (item) {
          var extraKey = _.last(item.id.split('.'));

          if (_.find(data, function (o) {
            return o.key.indexOf(extraKey) >= 0;
          })) {
            return;
          }

          var displayNameAry = item.name.split('-');
          data.push({
            displayName: displayNameAry[1] + '-' + displayNameAry[2],
            key: key + '.' + extraKey,
            isWeb: _.find(extraFunction, function (o) {
              return o.id.indexOf("web.".concat(key, ".").concat(extraKey)) >= 0;
            }),
            isEvms: _.find(extraFunction, function (o) {
              return o.id.indexOf("evms.".concat(key, ".").concat(extraKey)) >= 0;
            })
          });
        });
      }
    } else {
      _.forEach(menu.pages, function (page, i) {
        if (i > 0) {
          var webItem = _.find(menus, function (o) {
            return o.key.indexOf("web.".concat(key)) >= 0;
          });

          var _isWeb = webItem && webItem.pages.indexOf(page) >= 0;

          var evmsItem = _.find(menus, function (o) {
            return o.key.indexOf("evms.".concat(key)) >= 0;
          });

          var _isEvms = evmsItem && evmsItem.pages.indexOf(page) >= 0;

          var displayNameAry = menu.displayNames[i].split('-');

          if (!data.find(function (o) {
            return o.key === key + '.' + page;
          })) {
            data.push({
              displayName: "".concat(displayNameAry[1], "-").concat(displayNameAry[2]),
              key: key + '.' + page,
              isWeb: _isWeb,
              isEvms: _isEvms
            });
          }

          if (extraFunction.length > 0) {
            _.forEach(extraFunction, function (item) {
              var extraKey = _.last(item.id.split('.'));

              if (_.find(data, function (o) {
                return o.key.indexOf(extraKey) >= 0;
              })) {
                return;
              }

              var displayNameAry = item.name.split('-');

              var isWeb = _.find(extraFunction, function (o) {
                return o.id.indexOf("web.".concat(key, ".").concat(page, ".").concat(extraKey)) >= 0;
              });

              var isEvms = _.find(extraFunction, function (o) {
                return o.id.indexOf("evms.".concat(key, ".").concat(page, ".").concat(extraKey)) >= 0;
              });

              if (!isWeb && !isEvms) return;
              data.push({
                displayName: displayNameAry[1] + '-' + displayNameAry[2] + '-' + displayNameAry[3],
                key: "".concat(key, ".").concat(page, ".").concat(extraKey),
                isWeb: isWeb,
                isEvms: isEvms
              });
            });
          }
        }
      });
    }
  });

  if (noParentFunction.length > 0) {
    _.forEach(noParentFunction, function (item) {
      var key = item.id.split('.')[1];
      var extraKey = item.id.split(".".concat(key, "."))[1];

      if (_.find(data, function (o) {
        return o.key.indexOf(extraKey) >= 0;
      })) {
        return;
      }

      var displayName = item.name.split('-')[1];
      data.push({
        displayName: displayName,
        key: extraKey ? "".concat(key, ".").concat(extraKey) : key,
        isWeb: false,
        isEvms: true
      });
    });
  }

  return data;
};

var RightsTypeList = /*#__PURE__*/React.memo(function (props) {
  var _useSelector2 = useSelector(function (state) {
    return state.toJS();
  }),
      authorizations = _useSelector2.userManagement.authorizations; // const dispatch = useDispatch()


  var onCheckChange = props.onCheckChange,
      menus = props.menus,
      permissions = props.permissions;
  var data = useMemo(function () {
    return generateRightsMenu(menus, authorizations);
  }, [menus, authorizations]);

  _.forEach(data, function (item) {
    var webChecked = false,
        evmsChecked = false;
    if (item.isEvms) evmsChecked = !_.isEmpty(_.find(permissions, function (el) {
      return el.id === "evms.".concat(item.key);
    }));
    if (item.isWeb) webChecked = !_.isEmpty(_.find(permissions, function (el) {
      return el.id === "web.".concat(item.key);
    }));

    _.set(item, 'evms', {
      checked: evmsChecked
    });

    _.set(item, 'web', {
      checked: webChecked
    });
  });

  var handleCheckChange = function handleCheckChange(val, checked) {
    var currentItem = _.find(authorizations, function (o) {
      return o.id === val;
    });

    onCheckChange(val, checked ? 'del' : 'add', currentItem);
  };

  var fields = {};

  _.set(fields, 'displayName', {
    label: t('lbl-rights')
  });

  _.set(fields, 'web', {
    label: t('lbl-web'),
    formatter: function formatter(val, row) {
      if (!row.isWeb) return null;
      return /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          return handleCheckChange("web.".concat(row.key), val.checked);
        },
        checked: val.checked // disabled={val.default}

      });
    }
  });

  _.set(fields, 'evms', {
    label: t('lbl-evms'),
    formatter: function formatter(val, row) {
      if (!row.isEvms) return null;
      return /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          return handleCheckChange("evms.".concat(row.key), val.checked);
        },
        checked: val.checked // disabled={val.default}

      });
    }
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-role-rights')), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    data: data,
    fields: fields
  })));
});